import React, { Component } from "react";
import axios from "axios";
import {
  API_INFORMES,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_INICIAL,
  pdfEvalInicialScript,
  emptyDatosEvalInicial,
  normalizarDatosEvalInicial,
  estadoFirmaEspecialista,
  MSG_FIRMA_PDF_REQUERIDA,
  tituloFormularioEvalInicial,
} from "./api";
import FirmaEspecialistaInforme from "./FirmaEspecialistaInforme";
import AyudaFormEvalInicialModal from "./AyudaFormEvalInicialModal";
import {
  TIPO_CAMPO,
  CAMPOS_DATOS_GENERALES,
  CAMPOS_ANTECEDENTES,
  CAMPOS_AVD,
  CAMPOS_AVD_INSTRUMENTALES,
  CAMPOS_JUEGO,
  CAMPOS_DESEMPENO_ESCOLAR,
  CAMPOS_OCIO_TIEMPO_LIBRE,
  CAMPOS_COMUNICACION_SOCIAL,
  CAMPOS_PROCESAMIENTO_SENSORIAL,
  CAMPOS_MOTRICIDAD_FINA,
  CAMPOS_MOTRICIDAD_GRUESA,
  CAMPOS_CIERRE,
} from "./camposEvalInicial";

class InformeEvaluacionInicial extends Component {
  constructor(props) {
    super(props);
    this.firmaRef = React.createRef();
    this.state = {
      datos: emptyDatosEvalInicial(),
      guardando: false,
      tieneFirmaEsp: false,
      reportesModalAbierto: false,
      reportesCargando: false,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
      ayudaAbierta: false,
    };
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.idInforme !== this.props.idInforme ||
      prevProps.idasociarE !== this.props.idasociarE ||
      prevProps.initialDatos !== this.props.initialDatos
    ) {
      this.cargarDatos();
    }
  }

  cargarDatos = () => {
    if (this.props.initialDatos && !this.props.idInforme) {
      this.setState({
        datos: normalizarDatosEvalInicial(this.props.initialDatos),
      });
      return;
    }
    const { idInforme, cedulaPaciente, idasociarE } = this.props;
    if (idInforme > 0) {
      const data = new FormData();
      data.append("boton", "obtener");
      data.append("idInforme", idInforme);
      data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
      axios.post(API_INFORMES, data).then((res) => {
        if (res.data.variable1) {
          this.setState({
            datos: normalizarDatosEvalInicial(res.data.variable3),
          });
        }
      });
      return;
    }
    const data = new FormData();
    data.append("boton", "datosPacienteBase");
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("idasociarE", idasociarE);
    data.append("tipoInforme", TIPO_INFORME_EVAL_INICIAL);
    data.append("ramaEspecialidad", this.props.ramaEspecialidad || "OCUPACIONAL");
    axios.post(API_INFORMES, data).then((res) => {
      if (res.data.variable1) {
        const base = res.data.variable2;
        this.setState({
          datos: {
            ...emptyDatosEvalInicial(),
            datosGenerales: {
              ...emptyDatosEvalInicial().datosGenerales,
              ...base,
            },
          },
        });
      }
    });
  };

  setDg = (field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        datosGenerales: {
          ...this.state.datos.datosGenerales,
          [field]: value,
        },
      },
    });
  };

  setField = (field, value) => {
    this.setState({
      datos: { ...this.state.datos, [field]: value },
    });
  };

  setNested = (group, field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        [group]: { ...this.state.datos[group], [field]: value },
      },
    });
  };

  guardar = () => {
    const {
      cedulaPaciente,
      cedulaEspecialista,
      tipoEvaluacion,
      idasociarE,
      idasociarEGrupo,
      sede,
      idInforme,
      onGuardado,
    } = this.props;
    const { datos } = this.state;
    const dg = datos.datosGenerales;
    this.setState({ guardando: true });
    const data = new FormData();
    data.append("boton", "guardar");
    data.append("tipoInforme", TIPO_INFORME_EVAL_INICIAL);
    data.append("ramaEspecialidad", this.props.ramaEspecialidad || "OCUPACIONAL");
    data.append("idInforme", idInforme || 0);
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("cedulaEspecialista", cedulaEspecialista);
    data.append("tipoEvaluacion", tipoEvaluacion);
    data.append("idasociarE", idasociarE);
    const idsGrupo =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo
        : [idasociarE];
    data.append("idasociarEGrupo", idsGrupo.join(","));
    data.append("formato", "INFANTIL");
    data.append("fechaInforme", dg.fechaInforme);
    data.append("fechaInicioTerapia", dg.fechaInicioTerapia);
    data.append("sede", sede || "");
    data.append("usuario", cedulaEspecialista);
    data.append("datosJson", JSON.stringify(datos));
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ guardando: false });
      if (res.data.variable1) {
        alert("Fue guardada la Evaluacion Inicial");
        if (onGuardado) onGuardado(res.data.variable2);
      } else {
        alert(res.data.variable2 || res.data.variable3 || "Error al guardar.");
      }
    });
  };

  imprimir = async () => {
    const { idInforme, cedulaEspecialista } = this.props;
    const { tieneFirmaEsp } = this.state;
    if (!idInforme) {
      alert("Guarde el informe antes de imprimir.");
      return;
    }
    if (!cedulaEspecialista) {
      alert("No se identifico al especialista en sesion.");
      return;
    }
    let tieneFirma = tieneFirmaEsp;
    if (!tieneFirma) {
      try {
        const est = await estadoFirmaEspecialista(cedulaEspecialista);
        tieneFirma = est.tiene;
        if (tieneFirma) {
          this.setState({ tieneFirmaEsp: true });
        }
      } catch (e) {
        tieneFirma = false;
      }
    }
    if (!tieneFirma) {
      alert(MSG_FIRMA_PDF_REQUERIDA);
      if (this.firmaRef.current && this.firmaRef.current.abrirSelector) {
        this.firmaRef.current.abrirSelector();
      }
      return;
    }
    const script = pdfEvalInicialScript(this.props.ramaEspecialidad || "OCUPACIONAL");
    const urlPdf =
      API_INFORMES_PDF +
      script +
      "?idInforme=" +
      encodeURIComponent(String(idInforme));
    const data = new FormData();
    data.append("idInforme", idInforme);
    axios({
      method: "post",
      url: API_INFORMES_PDF + script,
      responseType: "arraybuffer",
      data,
    })
      .then((response) => {
        const buf = response.data;
        if (!buf || buf.byteLength < 100) {
          window.open(urlPdf, "_blank");
          return;
        }
        const u8 = new Uint8Array(buf);
        const esPdf =
          u8.length >= 4 &&
          u8[0] === 0x25 &&
          u8[1] === 0x50 &&
          u8[2] === 0x44 &&
          u8[3] === 0x46;
        if (!esPdf) {
          window.open(urlPdf, "_blank");
          return;
        }
        const blob = new Blob([buf], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob));
      })
      .catch(() => {
        window.open(urlPdf, "_blank");
      });
  };

  abrirReportes = () => {
    const { idasociarE, idasociarEGrupo } = this.props;
    const ids =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo.map((id) => String(id))
        : idasociarE
          ? [String(idasociarE)]
          : [];
    const idPrincipal = idasociarE || (ids.length > 0 ? ids[0] : "");
    if (!idPrincipal) {
      this.setState({ reportesError: "No se identificó el estudio (idasociarE)." });
      return;
    }
    const data = new FormData();
    data.append("boton", "listarReportesCita");
    data.append("idasociarE", idPrincipal);
    if (ids.length > 1) {
      data.append("idasociarEGrupo", ids.join(","));
    }
    this.setState({
      reportesModalAbierto: true,
      reportesCargando: true,
      reportesError: "",
      reportesCita: [],
      reportesDuplicados: 0,
    });
    axios
      .post(API_INFORMES, data)
      .then((res) => {
        if (res.data && res.data.variable1) {
          this.setState({
            reportesCargando: false,
            reportesCita: Array.isArray(res.data.variable2) ? res.data.variable2 : [],
            reportesDuplicados: Number(res.data.variable3 || 0),
          });
          return;
        }
        this.setState({
          reportesCargando: false,
          reportesError: (res.data && res.data.variable2) || "No se pudo cargar los reportes.",
        });
      })
      .catch((err) => {
        this.setState({
          reportesCargando: false,
          reportesError: err.message || "No se pudo cargar los reportes.",
        });
      });
  };

  cerrarReportes = () => {
    this.setState({ reportesModalAbierto: false });
  };

  renderControl = (config, value, onChange) => {
    const tipo = config.tipo || TIPO_CAMPO.LINEA;
    if (tipo === TIPO_CAMPO.FECHA) {
      return (
        <input
          type="date"
          className="ic-input ic-input-line"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    if (tipo === TIPO_CAMPO.MULTILINEA) {
      return (
        <textarea
          className="ic-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 2000}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="ic-input ic-input-line"
        maxLength={config.maxLength || 120}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  };

  renderCampoDg = (config) => {
    const dg = this.state.datos.datosGenerales;
    const val = config.key === "edadTexto" ? dg.edadTexto || dg.edad || "" : dg[config.key];
    return (
      <div className="ic-field" key={config.key}>
        <label className="ic-label">{config.label}</label>
        {this.renderControl(config, val, (v) => this.setDg(config.key, v))}
      </div>
    );
  };

  renderCampoRaiz = (config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[config.key], (v) =>
        this.setField(config.key, v)
      )}
    </div>
  );

  renderCampoGrupo = (grupo, config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[grupo][config.key], (v) =>
        this.setNested(grupo, config.key, v)
      )}
    </div>
  );

  renderSeccion = (titulo, children) => (
    <div className="ic-formSection">
      <h4>{titulo}</h4>
      {children}
    </div>
  );

  render() {
    const {
      guardando,
      reportesModalAbierto,
      reportesCargando,
      reportesError,
      reportesCita,
      reportesDuplicados,
    } =
      this.state;

    return (
      <div className="ic-panel ic-form-document">
        <div className="ic-formDocHeader">
          <p className="ic-formDocHeader-paciente">
            Paciente:{" "}
            <strong>{this.props.nombrePaciente || this.props.cedulaPaciente}</strong>
          </p>
          <button
            type="button"
            className="ic-link-ayuda"
            onClick={() => this.setState({ ayudaAbierta: true })}
          >
            Ayuda
          </button>
        </div>
        <p className="ic-formato-badge">
          <strong>
            {tituloFormularioEvalInicial(this.props.ramaEspecialidad || "OCUPACIONAL")}
          </strong>
        </p>
        <div className="ic-actions ic-actions-sticky">
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {this.renderSeccion(
          "Datos generales",
          <div className="ic-grid-datos">
            {CAMPOS_DATOS_GENERALES.map((c) => this.renderCampoDg(c))}
          </div>
        )}

        {this.renderSeccion(
          "Antecedentes",
          <div className="ic-grid-campos">
            {CAMPOS_ANTECEDENTES.map((c) => this.renderCampoGrupo("antecedentes", c))}
          </div>
        )}

        {this.renderSeccion(
          "Actividades básicas de la vida diaria",
          <div className="ic-grid-campos">
            {CAMPOS_AVD.map((c) => this.renderCampoGrupo("avd", c))}
          </div>
        )}

        {this.renderSeccion(
          "Actividades instrumentales de la vida diaria",
          <div className="ic-grid-campos">
            {CAMPOS_AVD_INSTRUMENTALES.map((c) =>
              this.renderCampoGrupo("avdInstrumentales", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Juego",
          <div className="ic-grid-campos">
            {CAMPOS_JUEGO.map((c) => this.renderCampoGrupo("juego", c))}
          </div>
        )}

        {this.renderSeccion(
          "Desempeño escolar",
          <div className="ic-grid-campos">
            {CAMPOS_DESEMPENO_ESCOLAR.map((c) =>
              this.renderCampoGrupo("desempenoEscolar", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Ocio y tiempo libre",
          <div className="ic-grid-campos">
            {CAMPOS_OCIO_TIEMPO_LIBRE.map((c) =>
              this.renderCampoGrupo("ocioTiempoLibre", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Comunicación e interacción social",
          <div className="ic-grid-campos">
            {CAMPOS_COMUNICACION_SOCIAL.map((c) =>
              this.renderCampoGrupo("comunicacionSocial", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Procesamiento sensorial",
          <div className="ic-grid-campos">
            {CAMPOS_PROCESAMIENTO_SENSORIAL.map((c) =>
              this.renderCampoGrupo("procesamientoSensorial", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Motricidad fina",
          <div className="ic-grid-campos">
            {CAMPOS_MOTRICIDAD_FINA.map((c) => this.renderCampoGrupo("motricidadFina", c))}
          </div>
        )}

        {this.renderSeccion(
          "Motricidad gruesa",
          <div className="ic-grid-campos">
            {CAMPOS_MOTRICIDAD_GRUESA.map((c) =>
              this.renderCampoGrupo("motricidadGruesa", c)
            )}
          </div>
        )}

        {this.renderSeccion(
          "Cierre",
          <div className="ic-grid-campos">
            {CAMPOS_CIERRE.map((c) => this.renderCampoRaiz(c))}
          </div>
        )}

        <FirmaEspecialistaInforme
          ref={this.firmaRef}
          cedulaEspecialista={this.props.cedulaEspecialista}
          onCambio={(tiene) => this.setState({ tieneFirmaEsp: tiene })}
        />

        <div className="ic-actions">
          <button type="button" className="boton" onClick={this.guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" className="boton" onClick={this.imprimir}>
            Imprimir PDF
          </button>
          {this.props.idInforme > 0 && this.props.onEliminar && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={() => this.props.onEliminar(this.props.idInforme)}
            >
              Eliminar informe
            </button>
          )}
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {reportesModalAbierto && (
          <div className="ic-modalOverlay" onClick={this.cerrarReportes}>
            <div className="ic-modalCard" onClick={(e) => e.stopPropagation()}>
              <div className="ic-modalHeader">
                <h4>Reportes de la cita</h4>
                <button type="button" className="boton" onClick={this.cerrarReportes}>
                  Cerrar
                </button>
              </div>
              {reportesCargando && <p>Cargando reportes...</p>}
              {!reportesCargando && reportesError && <div className="ic-msg">{reportesError}</div>}
              {!reportesCargando && !reportesError && reportesCita.length === 0 && (
                <p>No hay reportes registrados para este estudio.</p>
              )}
              {!reportesCargando && reportesDuplicados > 0 && (
                <p className="ic-hint">
                  Se ocultaron {reportesDuplicados} reporte(s) duplicado(s) en esta vista.
                </p>
              )}
              {!reportesCargando && reportesCita.length > 0 && (
                <div className="ic-modalList">
                  {reportesCita.map((r, idx) => (
                    <div key={`${r.idmensaje}-${idx}`} className="ic-modalItem">
                      <div>
                        <strong>Fecha cita:</strong> {r.fechaCita || "-"}{" "}
                        <span className="ic-hint">| Registro: {r.fechaMensaje || "-"}</span>
                      </div>
                      <div>
                        <strong>Mensaje:</strong> {r.mensaje || "(sin texto)"}
                      </div>
                      {r.ruta ? (
                        <div>
                          <strong>Adjunto:</strong> {r.ruta}
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        <AyudaFormEvalInicialModal
          abierto={this.state.ayudaAbierta}
          onCerrar={() => this.setState({ ayudaAbierta: false })}
        />
      </div>
    );
  }
}

export default InformeEvaluacionInicial;
